export enum TaskStatus {
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
  DELETED = "DELETED"
}

export const taskStatusToLabel = {
  [TaskStatus.TO_DO]: 'to do',
  [TaskStatus.IN_PROGRESS]: 'in progress',
  [TaskStatus.DONE]: 'done',
  [TaskStatus.DELETED]: 'deleted',
};

export const labelToTaskStatus = {
  ['to do']: TaskStatus.TO_DO,
  ['in progress']: TaskStatus.IN_PROGRESS,
  ['done']: TaskStatus.DONE,
  ['deleted']: TaskStatus.DELETED,
}
